export enum Socket {
	CASE_TAKEN = 'caseTaken',
	CASE_CREATED = 'caseCreated',
	USER_CONSENT_ACCEPTED = 'userConsentAccepted',
	USER_TYPING = 'userTyping',
}
